<template>
  <!-- v-bind:style="{ height: windowHeight-141 + 'px' }" -->
  <div id="fixedRoom" class="row styleScroll" v-bind:style="{ height: windowHeight-62 + 'px' }">
    <div class="col" style="padding-right: 0; padding-left: 0;">
      <div class="row" style=" background: rgb(49, 57, 76);">
        <div class="col-12 chatRoomsHeader-main">Your Conversations:</div>
      </div>

      <div
        class="row"
        style="background: rgb(49, 57, 76); color: #fff"
        v-if="rooms.filter(el => el.adminId == currAdmin.id).length == 0"
      >
        <div class="col-12">No conversations assigned to you</div>
      </div>
      <b-list-group v-if="rooms.filter(el => el.adminId == currAdmin.id).length > 0">
        <b-list-group-item
          :id="'room-' + rooms.findIndex(el => el.ssId == room.ssId)"
          class="roomListStyle"
          v-for="room in rooms.filter(el => el.adminId == currAdmin.id)"
          :key="room.key"
          v-on:click="selectedRoomId = room.ssId"
          action
        >
          <ChatRoom
            :key="'rm-' + room.key"
            :room="room"
            :msgs="messages[room.ssId]"
            :roomstatus="roomStats[room.ssId]"
            :selected="selectedRoomId == room.ssId"
            :myChat="true"
            :windowWidth="windowWidth"
            v-on:expiredRoom="$emit('expiredRoom', $event)"
          />
        </b-list-group-item>
      </b-list-group>

      <div style="margin-top: 10px;">
        <hr class="style-one" />
      </div>
      <!-- FollowUp Rooms -->

      <div class="row" style=" background: rgb(49, 57, 76); ">
        <div class="col-12 chatRoomsHeader-other" style="padding-top: 7px;">SMS Conversations:</div>
      </div>
      <div class="row" style="margin-bottom: 20px;">
        <div class="col-10" style="padding-right: 10px;">
          <!-- @change="isSelectedOnList" -->
          <b-form-select v-model="showActiveSms" size="sm" class="roomsListSelect">
            <b-form-select-option
              v-for="smsopt in [{text: 'active', val: true}, {text:'finished', val: false}]"
              :key="smsopt.text"
              :value="smsopt.val"
              class="roomsListOptions"
            >{{smsopt.text}}</b-form-select-option>
          </b-form-select>
        </div>
        <div class="col-2 nopadd">
          <button type="button" class="btn newSmsRoomBtn" v-b-modal.newSMSRoom>+</button>
        </div>
      </div>
      <div
        class="row"
        style="background: rgb(49, 57, 76); color: #fff"
        v-if="rooms.filter(el => el.adminId == '' && el.clientEndpoint == 'sms' && el.isActive == showActiveSms).length == 0"
      >
        <div class="col-12">No {{showActiveSms ? 'active' : 'finished'}} conversations</div>
      </div>
      <b-list-group
        v-if="rooms.filter(el => el.adminId == '' && el.clientEndpoint == 'sms' && el.isActive == showActiveSms).length > 0"
      >
        <b-list-group-item
          class="roomListStyle"
          :id="'flproom-' + rooms.findIndex(el => el.ssId == flproom.ssId)"
          v-for="flproom in rooms.filter(el => el.adminId == '' && el.clientEndpoint == 'sms' && el.isActive == showActiveSms)"
          :key="flproom.key"
          v-on:click="selectedRoomId = flproom.ssId"
          action
        >
          <ChatRoom
            :key="'frm-' + flproom.key"
            :room="flproom"
            :msgs="messages[flproom.ssId]"
            :roomstatus="roomStats[flproom.ssId]"
            :selected="selectedRoomId == flproom.ssId"
            :myChat="false"
            :windowWidth="windowWidth"
          />
        </b-list-group-item>
      </b-list-group>

      <div style="margin-top: 10px;">
        <hr class="style-one" />
      </div>

      <!-- Bot Conversations -->

      <div class="row">
        <div class="col-12 chatRoomsHeader-other">Other Conversations:</div>
      </div>
      <div class="row" style="background: rgb(49, 57, 76); margin-bottom: 20px;">
        <div class="col-12">
          <b-form-select
            v-model="selectedAdminToWatch"
            @change="isSelectedOnList"
            size="sm"
            class="roomsListSelect"
          >
            <b-form-select-option
              v-for="opt in watchAdminsList"
              :key="opt.value"
              :value="opt.value"
              class="roomsListOptions"
            >{{opt.text}}</b-form-select-option>
          </b-form-select>
        </div>
      </div>

      <!-- OTHER/BotRooms -->
      <div
        class="row"
        style="background: rgb(49, 57, 76); color: #fff"
        v-if="selectedAdminToWatch != '' && rooms.filter(el => el.adminId == selectedAdminToWatch).length == 0"
      >
        <div class="col-12">No conversations assigned to this representative</div>
      </div>

      <b-list-group
        v-if="selectedAdminToWatch != '' && rooms.filter(el => el.adminId == selectedAdminToWatch).length > 0"
      >
        <b-list-group-item
          :id="'botroom-' + rooms.findIndex(el => el.ssId == botroom.ssId)"
          class="roomListStyle"
          v-for="botroom in rooms.filter(el => el.adminId == selectedAdminToWatch)"
          :key="botroom.key"
          v-on:click="selectedRoomId = botroom.ssId"
          action
        >
          <ChatRoom
            :key="'brm-' + botroom.key"
            :room="botroom"
            :msgs="messages[botroom.ssId]"
            :roomstatus="roomStats[botroom.ssId]"
            :selected="selectedRoomId == botroom.ssId"
            :myChat="false"
            :windowWidth="windowWidth"
          />
        </b-list-group-item>
      </b-list-group>

      <div style="margin-top: 10px;">
        <hr class="style-one" />
      </div>
    </div>
  </div>
</template>

<script>
import ChatRoom from "./ChatRoom.vue";

export default {
  name: "ChatList",
  components: {
    ChatRoom
  },
  props: {
    rooms: Array,
    messages: Object,
    watchAdminsList: Array,
    currAdmin: Object,
    roomStats: Object,
    windowHeight: Number,
    windowWidth: Number
  },
  data() {
    return {
      selectedRoomId: "",
      selectedAdminToWatch: "bot",
      showActiveSms: true
    };
  },
  created() {},

  mounted() {},
  computed: {
    isRoomOnline() {
      return this.roomStats;
    }
  },
  watch: {
    showActiveSms: function(showActive) {
      if (
        this.selectedRoomId &&
        this.rooms.find(
          el =>
            el.clientEndpoint == "sms" &&
            el.ssId == this.selectedRoomId &&
            el.isActive != showActive
        )
      ) {
        this.selectedRoomId = "";
      }
    },
    rooms: function() {
      this.isSelectedOnList();
    },

    selectedRoomId: function() {
      this.$emit("roomSelected", this.selectedRoomId);
    }
  },

  methods: {
    isSelectedOnList() {
      let ar = this.rooms.filter(
        el =>
          el.adminId == this.selectedAdminToWatch ||
          (el.adminId == "" && el.clientEndpoint == "sms") ||
          el.adminId == this.currAdmin.id
      );

      this.selectedRoomId = ar.find(el => el.ssId == this.selectedRoomId)
        ? this.selectedRoomId
        : "";
    }
  }
};
</script>
<style scoped>
.roomListStyle {
  border: none;
  border-radius: none;
  /* border-bottom: 1px solid grey; */
  padding: 0px;
  cursor: pointer;
  background-color: rgb(49, 57, 76) !important;
  /* background-color: red; */
  color: #f5f5f5;

  -webkit-transition: 0.4s all;
  -webkit-transition-delay: 0.8s;
  -moz-transition: 0.4s all;
  -moz-transition-delay: 0.8s;
  -ms-transition: 0.4s all;
  -ms-transition-delay: 0.8s;
  -o-transition: 0.4s all;
  -o-transition-delay: 0.8s;
  transition: 0.4s all;
  transition-delay: 0.8s;
}

.roomListStyle {
  border: none;
  border-radius: none;
  /* border-bottom: 1px solid lightseagreen; */
  /* padding: 20px; */
  cursor: pointer;
  background-color: #496786;
  /* background-color: #496886; */
  -webkit-transition-delay: 0s;
  -moz-transition-delay: 0s;
  -ms-transition-delay: 0s;
  -o-transition-delay: 0s;
  transition-delay: 0s;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0rem;
  border-bottom-left-radius: 0rem;
}

.list-group-item:first-child {
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
}
.chatRoomsHeader-other {
  background: rgb(49, 57, 76);
  color: white;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 5px;
  text-align: left;
}

.chatRoomsHeader-main {
  color: white;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 15px;
  text-align: left;
}
.roomsListOptions {
  background: rgb(49, 57, 76);
  color: white;
}

.roomsListSelect {
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
}

#styleScroll::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3); */
  background-color: rgb(49, 57, 76);
}

#styleScroll::-webkit-scrollbar {
  width: 8px;
  background-color: rgb(49, 57, 76);
}

#styleScroll::-webkit-scrollbar-thumb {
  background-color: #243140;
}

.styleScroll::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3); */
  background-color: rgb(49, 57, 76);
}

.styleScroll::-webkit-scrollbar {
  width: 8px;
  background-color: rgb(49, 57, 76);
}

.styleScroll::-webkit-scrollbar-thumb {
  background-color: #243140;
}
#fixedRoom {
  /* position: fixed; */
  /* height: 97vh; */
  overflow-y: scroll;
  overflow-x: hidden;
  /* resize: vertical; */
  padding: 0px;
  background-color: rgb(49, 57, 76);
}

#chatLists .row,
#fixedRoom .row {
  margin-left: 0;
  margin-right: 0;
}
.nopaddLeft {
  padding-left: 0;
}
.nopadd {
  padding: 0;
}
.newSmsRoomBtn {
  padding-top: 3px;
  padding-bottom: 2px;
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
}
hr.style-one {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>